import type { BaseDevice } from './BaseDevice'
import type { HidChannel } from '../channels/hid/HidChannel'
import { DeviceManifest } from '../types/manifest'

type DeviceConstructor = new (channel: HidChannel, manifest: DeviceManifest) => BaseDevice

/**
 * 设备工厂
 * 负责根据 Manifest 中的 driver 字段创建对应的驱动实例
 */
export class DeviceFactory {
  private static registry: Map<string, DeviceConstructor> = new Map()

  /**
   * 注册驱动类
   * @param name 驱动名称 (对应 manifest.json 中的 driver 字段)
   * @param ctor 驱动类构造函数
   */
  static register(name: string, ctor: DeviceConstructor) {
    this.registry.set(name, ctor)
    console.log(`[DeviceFactory] Registered driver: ${name}`)
  }

  /**
   * 创建设备实例
   */
  static create(manifest: DeviceManifest, channel: HidChannel): BaseDevice {
    const DriverClass = this.registry.get(manifest.driver)

    if (!DriverClass) {
      throw new Error(`[DeviceFactory] Driver '${manifest.driver}' not registered.`)
    }

    return new DriverClass(channel, manifest)
  }
}
